<template>
  <div :style="{
      display:'flex',
      flexDirection:'column',
      backgroundImage:HNewGameUIConfig.newGameUIType === 4?`url(${icon_top_bg})`:'',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 80%',
      backgroundPosition: 'top',
      backgroundAttachment: 'fixed',
  }">
    <van-sticky v-if="HNewGameUIConfig.newGameUIType===4 && vipData!=null">
      <div v-if="!hideNav" :style="{
        backgroundColor:HNewGameUIConfig.newGameUIType === 0?dynamicBgColor:'#0000',
        padding:'10px 10px',
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center',
      }">
        <van-icon @click="hr.goBack" name="arrow-left" size="21" :color="HNewGameUIConfig.newGameUIType === 2 ||
                HNewGameUIConfig.newGameUIType === 3
            ? 'white'
            : 'black'"/>
        <div :style="hcf.getTextStyle({
            addSize:3,color:HNewGameUIConfig.newGameUIType === 2 ||
                HNewGameUIConfig.newGameUIType === 3
            ? 'white'
            : 'black'
          })">VIP特权
        </div>
        <div style="width:21px;"/>
      </div>
      <div style="position: relative;">
        <div :style="{
        display: 'flex',flexDirection: 'column',
        backgroundImage:`url(${jmttTopBg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'top',
        margin:'10px',
        borderRadius: '10px',
        overflow: 'hidden',
      }">
          <div :style="{
          display: 'flex',flexDirection: 'row',backgroundColor: 'white',
        }">
            <div style="width:60px;height:30px;position:relative;margin-right: 10px;">

            </div>
            <div style="display: flex;flex-direction: row;align-items: center;padding:10px;width:100%;">
              <div
                  :style="{
                    borderRadius:'4px',
                    padding:'1px 4px',
                   }">
                <div v-if="HNewGameUIConfig.newGameUIType !== 3" :style="hcf.getTextStyle({
                    color:'#917254',
                    fontWeight:'bold'
              })">
                  VIP.{{ user.vipLevel }}
                </div>
              </div>
              <div
                  style="padding:0 10px 10px 10px;width:100%;display: flex;flex-direction: column;align-items: center;">
                <div
                    style="width:100%;display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
                  <div v-if="HNewGameUIConfig.newGameUIType !== 3" :style="hcf.getTextStyle({
                  color:'#65a1d4',
                  addSize:-2,fontWeight:'bold',marginLeft:5,
                })">
                    {{ vipData["CurrentExp"] }}{{ " / " }}{{ vipData["NextExp"] }}
                  </div>
                  <div v-if="HNewGameUIConfig.newGameUIType !== 3" :style="hcf.getTextStyle({
                  color:'#65a1d4',
                  addSize:-2,fontWeight:'bold',marginRight:5
                })">
                    {{ progressValue + '%' }}
                  </div>
                </div>
                <van-progress
                    :style="{
                      backgroundColor:'#aaa',
                      height:'8px',
                      width:'100%'
                    }"
                    :percentage="progressValue"
                    pivot-text=""
                    pivot-color="#FFBC90"
                    text-color="#a00"
                    :color="HNewGameUIConfig.newGameUIType === 0?'linear-gradient(to right, #FFBC90, #EABC90)':'linear-gradient(to right, #ff8e00, #EABC90)'"
                />
              </div>
              <img v-if="HNewGameUIConfig.newGameUIType === 3" :src="iconVipNextLevel" style="height:15px;" alt="">
              <div v-if="HNewGameUIConfig.newGameUIType !== 3"
                   :style="{
                    borderRadius:'4px',
                    padding:'1px 4px',
                   }">
                <div v-if="HNewGameUIConfig.newGameUIType !== 3" :style="hcf.getTextStyle({
              color:'#917254',
              fontWeight:'bold'
            })">
                  VIP.{{ user.vipLevel + 1 }}
                </div>
              </div>
            </div>
          </div>
          <div style="display:flex;flex-direction: column;justify-content: center;">
            <div style="display:flex;flex-direction: row;align-items: center">
              <div :style="hcf.getTextStyle({
                  fontWeight:'bold',addSize:2,marginLeft:15,
              })">
                {{ hcf.getShowNamePhoneId(user) }}
              </div>
              <img :src="iconVipFlag" style="height:20px;margin-left: 5px;" alt="">
            </div>
            <div style="display:flex;flex-direction: row;align-items: center;margin:0 15px;justify-content: space-between;margin-bottom: 6px;">
              <div :style="hcf.getTextStyle({
                  addSize:-3,
                  color:'#a00',
          })">
                {{
                  user.vipLevel <= 0 ? `您已注册第${vipData["VipDays"]}天` : `您已成为 VIP${user.vipLevel} 第${vipData["VipDays"] ?? "-"}天`
                }}
              </div>
              <div @click="goVipDetail" style="display: flex;flex-direction: row;align-items: center;">
                <div :style="hcf.getTextStyle({
                    addSize: 0,
                    color:'#a00',
                    textDecoration:HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 2 ?'underline':'normal',
                })">
                  VIP详情
                </div>
                <van-icon name="arrow" size="13" color="#a00"/>
              </div>
            </div>
          </div>
        </div>
        <HAvatar style="position: absolute;top:-10px;left:20px;" radius="30px"/>
      </div>
    </van-sticky>
    <van-sticky v-if="HNewGameUIConfig.newGameUIType!==4">
      <div :style="{
      display:'flex',
      flexDirection:'column',
      backgroundImage:HNewGameUIConfig.newGameUIType === 0 || HNewGameUIConfig.newGameUIType === 4?'':`url(${icon_top_bg})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      backgroundPosition: 'top',
    }">
        <div v-if="!hideNav" :style="{
        backgroundColor:HNewGameUIConfig.newGameUIType === 0?dynamicBgColor:'#0000',
        padding:'10px 10px',
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center',
      }">
          <van-icon @click="hr.goBack" name="arrow-left" size="21" :color="HNewGameUIConfig.newGameUIType === 2 ||
                HNewGameUIConfig.newGameUIType === 3
            ? 'white'
            : 'black'"/>
          <div :style="hcf.getTextStyle({
            addSize:3,color:HNewGameUIConfig.newGameUIType === 2 ||
                HNewGameUIConfig.newGameUIType === 3
            ? 'white'
            : 'black'
          })">VIP特权
          </div>
          <div style="width:21px;"/>
        </div>
        <div v-if="vipData!=null">
          <div style="display: flex;flex-direction: column;">
            <div :style="{
          display:'flex',flexDirection: 'row',alignItems: 'center',padding:'10px',
          backgroundColor:HNewGameUIConfig.newGameUIType === 0?dynamicBgColor:'#0000',justifyContent:'space-between'
        }">
              <div style="display:flex;flex-direction: row;">
                <HAvatar style="margin-right: 10px;" radius="30px"/>
                <div style="display:flex;flex-direction: column;justify-content: center;">
                  <div style="display:flex;flex-direction: row;align-items: center">
                    <div :style="hcf.getTextStyle({
                  fontWeight:'bold',addSize:2,
                  color:HNewGameUIConfig.newGameUIType === 3 ?'#cb8c07':HNewGameUIConfig.newGameUIType === 2?'white':'',
              })">
                      {{ hcf.getShowNamePhoneId(user) }}
                    </div>
                    <img :src="iconVipFlag" style="height:20px;margin-left: 5px;" alt="">
                  </div>
                  <div :style="hcf.getTextStyle({
                  addSize:-3,
                  color:HNewGameUIConfig.newGameUIType === 1?'#cb8c07':HNewGameUIConfig.newGameUIType === 2?'#333':'#888',
          })">
                    {{
                      user.vipLevel <= 0 ? `您已注册第${vipData["VipDays"]}天` : `您已成为 VIP${user.vipLevel} 第${vipData["VipDays"] ?? "-"}天`
                    }}
                  </div>
                </div>
              </div>
              <div @click="goVipDetail" :style="{
          padding:'3px 6px',borderRadius: '5px',
          backgroundColor: HNewGameUIConfig.newGameUIType !== 0?'#0000':dynamicTextColor
        }">
                <div style="display: flex;flex-direction: row;align-items: center;">
                  <div :style="hcf.getTextStyle({
              addSize: HNewGameUIConfig.newGameUIType ===0?-2:0,
              color:HNewGameUIConfig.newGameUIType === 1?'#cb8c07':HNewGameUIConfig.newGameUIType === 2?'#333':'white',
              textDecoration:HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 2 ?'underline':'normal',
          })">
                    VIP详情
                  </div>
                  <van-icon v-if="HNewGameUIConfig.newGameUIType === 3" name="arrow" size="13" color="white"/>
                </div>
              </div>
            </div>
            <div :style="{
          display: 'flex', flexDirection: 'column',backgroundColor: HNewGameUIConfig.newGameUIType === 0?dynamicBgColor:'#0000'
        }">
              <div style="display: flex;flex-direction: row;align-items: center;padding:10px;">
                <img v-if="HNewGameUIConfig.newGameUIType === 3" :src="iconVipLevel" style="height:15px;" alt="">
                <div v-if="HNewGameUIConfig.newGameUIType !== 3"
                     :style="{
                    borderRadius:'4px',
                    padding:'1px 4px',
                    backgroundColor: HNewGameUIConfig.newGameUIType === 1?'#777':HNewGameUIConfig.newGameUIType===2?'#c23030':'#f6f6f6',
                   }">
                  <div v-if="HNewGameUIConfig.newGameUIType !== 3" :style="hcf.getTextStyle({
              color:HNewGameUIConfig.newGameUIType === 0?dynamicTextColor:'white',
              fontWeight:'bold'
        })">
                    VIP.{{ user.vipLevel }}
                  </div>
                </div>
                <div
                    style="padding:0 10px 10px 10px;width:100%;display: flex;flex-direction: column;align-items: center;">
                  <div
                      style="margin-bottom: 5px;width:100%;display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
                    <div :style="hcf.getTextStyle({
              color:HNewGameUIConfig.newGameUIType === 3?'#aaa':HNewGameUIConfig.newGameUIType === 1?'#777':HNewGameUIConfig.newGameUIType === 0?dynamicTextColor:'white',
              addSize:-2,fontWeight:'bold',marginLeft:5,
            })">
                      {{ vipData["CurrentExp"] }}{{ "/" }}{{ vipData["NextExp"] }}
                    </div>
                    <div :style="hcf.getTextStyle({
              color:HNewGameUIConfig.newGameUIType === 3?'#aaa':HNewGameUIConfig.newGameUIType === 1?'#777':HNewGameUIConfig.newGameUIType === 0?dynamicTextColor:'white',
              addSize:-2,fontWeight:'bold',marginRight:5
            })">
                      {{ progressValue + '%' }}
                    </div>
                  </div>
                  <van-progress
                      :style="{
                      backgroundColor: HNewGameUIConfig.newGameUIType === 1?'#999':HNewGameUIConfig.newGameUIType === 2?'#fff':HNewGameUIConfig.newGameUIType === 3?'#444':'white',
                      height:'8px',
                      width:'100%'
                    }"
                      :percentage="progressValue"
                      pivot-text=""
                      pivot-color="#FFBC90"
                      text-color="#a00"
                      :color="HNewGameUIConfig.newGameUIType === 0?'linear-gradient(to right, #FFBC90, #EABC90)':'linear-gradient(to right, #ff8e00, #EABC90)'"
                  />
                </div>
                <img v-if="HNewGameUIConfig.newGameUIType === 3" :src="iconVipNextLevel" style="height:15px;" alt="">
                <div v-if="HNewGameUIConfig.newGameUIType !== 3"
                     :style="{
                    borderRadius:'4px',
                    padding:'1px 4px',
                    backgroundColor: HNewGameUIConfig.newGameUIType === 1?'#777':HNewGameUIConfig.newGameUIType===2?'#c23030':'#f6f6f6',
                   }">
                  <div v-if="HNewGameUIConfig.newGameUIType !== 3" :style="hcf.getTextStyle({
              color:HNewGameUIConfig.newGameUIType === 0?dynamicTextColor:'white',
              fontWeight:'bold'
            })">
                    VIP.{{ user.vipLevel + 1 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-sticky>
    <div v-if="vipData!=null && (HNewGameUIConfig.newGameUIType===1 ||  HNewGameUIConfig.newGameUIType===2)"
         ref="scrollTagRef" class="scrollable-tags"
         style="padding:6px 10px;margin:5px 10px 10px 10px;background-color: #888;border-radius:10px;">
      <div style="display:flex;flex-direction: row;align-items: center;" v-for="index in 11" :key="index">
        <div @click="goSwiperPageByIndex(index-1)" class="eachTag"
             :style="{
                backgroundColor:(index-1) === curSwiperIndex
                        ? ((HNewGameUIConfig.newGameUIType === 1 ||
                                HNewGameUIConfig.newGameUIType === 2)
                            ? '#FEDB48'
                            : dynamicTextColor)
                        : ((HNewGameUIConfig.newGameUIType === 1 ||
                                HNewGameUIConfig.newGameUIType === 2)
                            ? '#FFFEDE'
                            : '#C4CEDB'),
                            color:(HNewGameUIConfig.newGameUIType === 1 ||
                                HNewGameUIConfig.newGameUIType === 2)
                            ? 'black'
                            : 'white'
             }">
          VIP.{{ index - 1 }}
        </div>
        <div v-if="index<=10" :style="{
            width:'18px',
            height:'1px',
            backgroundColor: (HNewGameUIConfig.newGameUIType === 1 ||
                          HNewGameUIConfig.newGameUIType === 2)
                      ? '#FFFEDE'
                      : '#0001'
          }"/>
      </div>
    </div>
    <div v-if="vipData!=null" :style="{
          margin:HNewGameUIConfig.newGameUIType === 4 ?'0 10px':'0',
          borderRadius:HNewGameUIConfig.newGameUIType === 4 ?'10px':'0',
          backgroundColor: HNewGameUIConfig.newGameUIType === 3?'#272727':HNewGameUIConfig.newGameUIType === 4 ?'#0000':dynamicBgColor,
          display: 'flex', flexDirection: 'column',position:'relative'
        }">
      <div :style="{
        backgroundColor:HNewGameUIConfig.newGameUIType === 4 ? 'white':'#0000',
        marginBottom:HNewGameUIConfig.newGameUIType === 4 ? '10px':'0',
        borderRadius:HNewGameUIConfig.newGameUIType === 4 ? '10px':'0',
        border:HNewGameUIConfig.newGameUIType === 4 ? '#a006 1px solid':'',
        paddingTop:HNewGameUIConfig.newGameUIType === 4 ? '0':'10px',
        position:HNewGameUIConfig.newGameUIType === 4 || HNewGameUIConfig.newGameUIType === 3?'relative':'',

        backgroundImage:HNewGameUIConfig.newGameUIType === 3?`url(${hsCardBg})`:'',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 120%',
        backgroundPosition: 'top',

      }">
        <img v-if="HNewGameUIConfig.newGameUIType === 4" :src="jmttCardBg" alt="" style="position:absolute;bottom:45px;width:90%;left:5%">
        <swiper
            @swiper="setControlledSwiper"
            :modules="HNewGameUIConfig.newGameUIType === 4 || HNewGameUIConfig.newGameUIType === 3 ?[]:[EffectCoverflow]"
            :effect="HNewGameUIConfig.newGameUIType === 4|| HNewGameUIConfig.newGameUIType === 3 ?'':'coverflow'"
            :grabCursor="HNewGameUIConfig.newGameUIType!==4 || HNewGameUIConfig.newGameUIType !== 3"
            :centeredSlides="HNewGameUIConfig.newGameUIType!==4 || HNewGameUIConfig.newGameUIType !== 3"
            :slidesPerView="HNewGameUIConfig.newGameUIType === 4 || HNewGameUIConfig.newGameUIType === 3?1:1.25"
            :spaceBetween="16"
            :initialSlide="curSwiperIndex"
            :coverflowEffect="HNewGameUIConfig.newGameUIType === 4 ? {}:{
              rotate: 0,
              stretch: 0,
              depth: 100,
              modifier: 1,
              scale: 0.9,
            }"
            style="width:100%;"
            @slideChange="swiperChange"
            @touchstart.stop
        >
          <swiper-slide v-for="(eachVip, index) in vipData['VipInfo']"
                        :key="index"
          >
            <div style="position:relative;display:flex;align-items: center;flex-direction: row;justify-content:center;">
              <div :style="{width:HNewGameUIConfig.newGameUIType === 4 ?'18px':'30px'}" v-if="index===0 && (HNewGameUIConfig.newGameUIType === 4 || HNewGameUIConfig.newGameUIType === 3)"/>
              <img @click="goSwiperPageByIndex(curSwiperIndex - 1)" v-if="index!==0 && (HNewGameUIConfig.newGameUIType === 4 || HNewGameUIConfig.newGameUIType === 3)" :src="iconCardLeft"
                   :style="{
                      height:'80px',
                      marginTop: HNewGameUIConfig.newGameUIType === 3 ?'0':'28px',
                      marginRight: '6px',
                    }" alt="">
              <HCacheImage :src="eachVip['Icon']"
                           :width="HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 2 ?'315px':'310px'"
                           :height="HNewGameUIConfig.newGameUIType === 4 ?'170px':HNewGameUIConfig.newGameUIType === 1 ?'150px': HNewGameUIConfig.newGameUIType === 2?'152px':'161px'"
                           alt="">
                <img v-if="HNewGameUIConfig.newGameUIType !== 4" :src="user.vipLevel >= index
                              ?iconVipUnLock:iconVipLock" :style="{
                    position:'absolute',
                    left:HNewGameUIConfig.newGameUIType === 3 ?'230.5px':HNewGameUIConfig.newGameUIType === 1?'6.5px':HNewGameUIConfig.newGameUIType === 2?'7.5px':'6px',
                    top:HNewGameUIConfig.newGameUIType === 3 ?'108px':HNewGameUIConfig.newGameUIType === 1?'5px':HNewGameUIConfig.newGameUIType === 2?'5.5px':'19px',
                    height:'12px',
                  }" alt="">

                <div v-if="HNewGameUIConfig.newGameUIType === 4" :style="{
                  backgroundColor:'#333',
                  position:'absolute',
                  borderTopRightRadius:'10px',
                  borderBottomRightRadius:'10px',
                  left:'10px',
                  top:'33px',
                  padding:'0 8px 0 5px',
                }"  >
                  <img :src="user.vipLevel >= index
                              ?iconVipUnLock:iconVipLock" :style="{
                    height:'12px',
                  }" alt="">
                </div>
                <div :style="{
                  position: 'absolute',
                  left:HNewGameUIConfig.newGameUIType === 3?'50px':HNewGameUIConfig.newGameUIType === 4?'45px':HNewGameUIConfig.newGameUIType === 1?'35px':HNewGameUIConfig.newGameUIType === 2?'120px':'55px',
                  bottom:HNewGameUIConfig.newGameUIType === 1?'51px':HNewGameUIConfig.newGameUIType === 2?'88px':'47px',
                }">
                      <div :style="hcf.getTextStyle({
                     color:getSwiperTextColor(),addSize:HNewGameUIConfig.newGameUIType === 4 ? -3:-1,
                })">
                    {{ `有效流水：${eachVip["ValidBetAmount"] > 0 ? eachVip["ValidBetAmount"] : "满级"}` }}
                  </div>
                </div>
                <div :style="{
              position: 'absolute',
              left:HNewGameUIConfig.newGameUIType === 3?'50px':HNewGameUIConfig.newGameUIType === 4?'45px':HNewGameUIConfig.newGameUIType === 1?'35px':HNewGameUIConfig.newGameUIType === 2?'120px':'55px',
              bottom:HNewGameUIConfig.newGameUIType === 1?'30px':HNewGameUIConfig.newGameUIType === 2?'68px':'28px',
            }">
                  <div :style="hcf.getTextStyle({
                color:getSwiperTextColor(),addSize:HNewGameUIConfig.newGameUIType === 4 ? -3:-1,
            })">
                    {{ `保级流水90天：${eachVip["SaveLevelBetAmount"]}` }}
                  </div>
                </div>
              </HCacheImage>
              <img @click="goSwiperPageByIndex(curSwiperIndex + 1)" v-if="index!==vipData['VipInfo'].length-1 && (HNewGameUIConfig.newGameUIType === 4 || HNewGameUIConfig.newGameUIType === 3)" :src="iconCardRight"
                   :style="{
                      height:'80px',
                      marginTop: HNewGameUIConfig.newGameUIType === 3 ?'0':'28px',
                      marginLeft: '6px',
                   }" alt="">
              <div :style="{width:HNewGameUIConfig.newGameUIType === 4 ?'18px':'30px'}" v-if="index===vipData['VipInfo'].length-1 && (HNewGameUIConfig.newGameUIType === 4 || HNewGameUIConfig.newGameUIType === 3)"/>
            </div>
          </swiper-slide>
        </swiper>
        <div v-if="curSwiperIndex!==user.vipLevel" @click="goSwiperPageByIndex(-1)" :style="{
            zIndex:1,
            position:'absolute',
            right:HNewGameUIConfig.newGameUIType === 4 ? '0':'10px',
            top:'0',
            backgroundColor:getBackTextBtnBgColor(),
            padding:'4px 6px',
            borderRadius:HNewGameUIConfig.newGameUIType === 4 ?'0':HNewGameUIConfig.newGameUIType === 0 ?'5px':'20px',
            borderTopLeftRadius:HNewGameUIConfig.newGameUIType ===4 ? '20px':HNewGameUIConfig.newGameUIType === 0 ?'5px':'20px',
            borderBottomLeftRadius:HNewGameUIConfig.newGameUIType ===4 ? '20px':HNewGameUIConfig.newGameUIType === 0 ?'5px':'20px',
            border:HNewGameUIConfig.newGameUIType === 4?'1px #FFDAD5 solid':'1px white solid',
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
          }">
          <van-icon name="arrow-left" size="13" :color="HNewGameUIConfig.newGameUIType === 4? '#E07070': 'white'"/>
          <div :style="hcf.getTextStyle({
            color:HNewGameUIConfig.newGameUIType === 4? '#E07070': 'white',addSize:-2,
        })">
            返回当前
          </div>
        </div>
        <VipRenderCircleWidgets ref="vipCircleRef" v-if="HNewGameUIConfig.newGameUIType===3"
                                style="position:absolute;bottom:-7px;z-index:10"/>
        <div v-if="HNewGameUIConfig.newGameUIType!==1 && HNewGameUIConfig.newGameUIType!==2 && HNewGameUIConfig.newGameUIType!==3" ref="scrollTagRef"
             class="scrollable-tags" style="margin-top: 10px;padding:10px;">
          <div style="display:flex;flex-direction: row;align-items: center;" v-for="index in 11" :key="index">
            <div @click="goSwiperPageByIndex(index-1)" class="eachTag"
                 :style="{
                fontSize: HNewGameUIConfig.newGameUIType === 4 ?'12px':'14px',
                borderRadius:HNewGameUIConfig.newGameUIType === 4 ?'20px':'6px',
                backgroundColor:(index-1) === curSwiperIndex
                        ? ((HNewGameUIConfig.newGameUIType === 1 ||
                                HNewGameUIConfig.newGameUIType === 2)
                            ? '#FEDB48'
                            : dynamicTextColor)
                        : ((HNewGameUIConfig.newGameUIType === 1 ||
                                HNewGameUIConfig.newGameUIType === 2)
                            ? '#FFFEDE'
                            : '#C4CEDB'),
                            color:(HNewGameUIConfig.newGameUIType === 1 ||
                                HNewGameUIConfig.newGameUIType === 2)
                            ? 'black'
                            : 'white'
             }">
              VIP.{{ index - 1 }}
            </div>
            <div v-if="index<=10" :style="{
            width:'18px',
            height:'1px',
            backgroundColor: HNewGameUIConfig.newGameUIType === 4?'#ccc':(HNewGameUIConfig.newGameUIType === 1 ||
                          HNewGameUIConfig.newGameUIType === 2)
                      ? '#FFFEDE'
                      : '#0001'
          }"/>
          </div>
        </div>

      </div>
      <div v-if="HNewGameUIConfig.newGameUIType === 3" style="height:1px;width:90%;background-color:#3a3a3a;margin-left: 5%;margin-top:36px;margin-bottom: 10px;"/>
      <div :style="{
        backgroundImage:HNewGameUIConfig.newGameUIType === 4?`url(${jmttPrivilegesBg})`:'',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'top',
      }">
        <div :style="{
          display:'flex',
          flexDirection:'row',
          alignItems:'center',
          justifyContent:HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 2?'center':'flex-start',
          marginBottom:HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 2?'5px':'0',
        }">
          <img v-if="HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 2"
               :src="icon_vip_tequan_flag_left" :style="{
          width:'30px',marginTop:'5px',
        }" alt="">
          <div v-if="HNewGameUIConfig.newGameUIType === 4 " style="margin-left: 10px;"/>
          <img :src="iconPVipTextArray[curSwiperIndex]" :style="{
          height:'15px',
          width:260/42*15+'px',
          marginTop: '15px',marginLeft: '10px',marginBottom: '10px',
          filter: HNewGameUIConfig.newGameUIType === 3?'brightness(0) invert(1)':'',
        }" alt="">

          <img v-if="HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 2"
               :src="icon_vip_tequan_flag_right" :style="{
          width:'30px',marginLeft:'10px',marginTop:'5px',
        }" alt="">

        </div>
        <div style="display:flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
          <div v-for="(eachP,index) in vipData['VipInfo'][curSwiperIndex]['Privilege']"
               :style="{
              width:'25%',
              display:'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginLeft:HNewGameUIConfig.newGameUIType === 4 && index === 0?'10px':'0',
              backgroundImage:HNewGameUIConfig.newGameUIType === 4?`url(${jmttEachPrivilegesBg})`:'',
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100% 100%',
              backgroundPosition: 'top',
              }" key="index">
            <div v-if="HNewGameUIConfig.newGameUIType === 4 " style="height:10px"/>
            <HCacheImage :src="eachP['Icon']" width="42px" height="42px" alt=""/>
            <div :style="hcf.getTextStyle({
            color: HNewGameUIConfig.newGameUIType === 4
                        ? '#FFE99B'
                        : '#E08900',addSize:hcf.isHaveChinese(eachP['Title'])?-1:1
          })">{{ eachP["Title"] }}
            </div>
            <div v-if="HNewGameUIConfig.newGameUIType === 4 " style="height:2px"/>
            <div :style="hcf.getTextStyle({
            color:HNewGameUIConfig.newGameUIType === 3
                        ? 'white'
                        : 'black',addSize:-1
          })">{{ eachP["Desc"] }}
            </div>
            <div v-if="HNewGameUIConfig.newGameUIType === 4 " style="height:3px"/>
          </div>
        </div>
      </div>
    </div>


    <div v-if="vipData!=null"
         :style="{
            display: 'flex',
            flexDirection: 'column',
            margin:HNewGameUIConfig.newGameUIType===4?'10px':'0',
            border:HNewGameUIConfig.newGameUIType===4?'#a006 1px solid':'',
            borderRadius:HNewGameUIConfig.newGameUIType===4?'10px':'0',
            background: HNewGameUIConfig.newGameUIType === 4 ?'linear-gradient(to bottom,#FFF5CA 0%,#FFF5CA 10%,white 20%, white 100%)':'',
            backgroundColor: HNewGameUIConfig.newGameUIType === 3?'#1a1a1a':HNewGameUIConfig.newGameUIType === 4 ?'#0000':'white',
            padding:'10px 10px 0 10px',
         }">
      <div v-for="(item,itemIndex) in vipData['VipTask']" :key="itemIndex"
           :style="{
              marginBottom: '10px',
              display: 'flex',
              flexDirection: 'column',
           }">
        <div :style="{
          display:'flex',
          flexDirection:'row',
          alignItems:'center',
          justifyContent:HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 2?'center':'flex-start',
          marginBottom:HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 2?'5px':'0',
        }">
          <img v-if="HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 2"
               :src="icon_vip_tequan_flag_left" :style="{
          width:'30px',marginRight:'10px',
        }" alt="">

          <div v-if="HNewGameUIConfig.newGameUIType === 4 " style="margin-left:8px;"/>
          <HCacheImage :src="item['GroupIcon']" height="16px" :isTurnWhite="HNewGameUIConfig.newGameUIType === 3"/>

          <img v-if="HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 2"
               :src="icon_vip_tequan_flag_right" :style="{
          width:'30px',marginLeft:'10px',
        }" alt="">

        </div>

        <div style="display:flex;flex-direction: row;align-items: center;"
             v-for="(eachTask,index) in item['GroupData']" :key="eachTask['Title']">
          <div style="display: flex;flex-direction: column;width:100%;">
            <div style="align-items: center;padding:10px;display: flex;flex-direction: row;width:100%;">
              <HCacheImage :src="eachTask['Icon']" height="50px"/>
              <div style="padding: 0 10px;display: flex;flex-direction: column;align-items: flex-start;width:100%;">
                <HParseColoredText :targetString="eachTask['Title']"
                                   :defaultColor="HNewGameUIConfig.newGameUIType === 3? '#FFBB10': 'black'"/>
                <van-progress
                    style="margin: 6px 0; background-color: #ddd;height:6px;width:100%"
                    :percentage="parseInt(`${eachTask['Progress']*100>100?100:eachTask['Progress']*100}`)"
                    :pivot-text="parseInt(`${eachTask['Progress']*100>100?100:eachTask['Progress']*100}`)+'%'"
                    pivot-color="#FFBC90"
                    text-color="#a00"
                    color="linear-gradient(to right, #FFBC90, #EABC90)"
                />
                <HParseColoredText :defaultColor="HNewGameUIConfig.newGameUIType === 3 ?'#aaa':'#333'" :targetString="eachTask['Desc']" :addFontSize="-3"/>
                <HCountdownTimer
                    v-if='eachTask["Limit"] != null && eachTask["Limit"] !== 0'
                    frontStr="限时完成:"
                    lastStr="后截止"
                    :countdownSecs='eachTask["Limit"]'
                    :countdownColor="eachTask['LimitColor']? `#${eachTask['LimitColor']}` : '#fa1818'"
                    :countdownFontSizeAdd="eachTask['LimitFontSizeAdd']??0"
                />
              </div>
              <div style="display:flex;flex-direction: column;align-items: flex-end;">
                <div @click="clickTaskBtn(eachTask)" :style="{
                    position:'relative',
                    marginBottom:eachTask['ButtonDesc']!==''?'2px':'',
                    display:'flex',width:'75px',height:'32px',alignItems:'center',justifyContent:'center',
                    borderRadius: HNewGameUIConfig.newGameUIType === 4
                                                  ? '30px'
                                                  : '5px',
                      backgroundColor: `#${eachTask['ButtonColor'].length>6?(eachTask['ButtonColor'].slice(2,eachTask['ButtonColor'].length)+eachTask['ButtonColor'].slice(0,2)):eachTask['ButtonColor']}`}">
                  <HParseColoredText :targetString="eachTask['ButtonTitle']" defaultColor="white" align="center"/>
                  <div v-if="eachTask['ButtonRedPoint']"
                       style="position:absolute;right:-2px;top:-2px;background-color: red;width:8px;height:8px;border-radius: 10px;"/>
                </div>
                <HParseColoredText v-if="eachTask['ButtonDesc']!==''" :targetString="eachTask['ButtonDesc']"
                                   :defaultColor="HNewGameUIConfig.newGameUIType === 3? 'white': 'black'" align="center"
                                   :addFontSize="-3"/>
              </div>
            </div>
            <div v-if="eachTask['Remark'] != null && eachTask['Remark'] != ''" :style="hcf.getTextStyle({
                addSize: eachTask['RemarkFontSizeAdd'] ?? -3,color:eachTask['RemarkColor'] !== '' ? `#${eachTask['RemarkColor']}` : '#aaaaaa'
            })">
              {{ eachTask['Remark'] }}
            </div>
            <van-divider v-if="index < item['GroupData'].length -1" style="margin:0"/>
          </div>
        </div>
      </div>
    </div>
    <van-button v-if="vipData!=null && HNewGameUIConfig.newGameUIType !== 4" @click="goVipDetail" :color="getJbBtnColor"
                :style="{
                  marginTop: '10px',
                  width:'80%',
                  marginLeft: '10%',
                  borderRadius: HNewGameUIConfig.newGameUIType === 3 ?'10px':'20px',
                  color:HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 3 ?'#333':'white'
              }">
      VIP详情
    </van-button>

    <img  @click="goVipDetail" v-if="vipData!=null && HNewGameUIConfig.newGameUIType === 4" :src="jmttVipDetailBtn" alt="" style="width:90%;margin-left:5%;margin-top: 10px;">

    <div v-if="vipData!=null" style="display:flex;flex-direction: column;padding: 10px">
      <div v-if="HNewGameUIConfig.newGameUIType !== 4" :style="hcf.getTextStyle({
      addSize:1,fontWeight:'bold',color:HNewGameUIConfig.newGameUIType === 3? 'white': 'main'
      })">说明
      </div>
      <img v-if="HNewGameUIConfig.newGameUIType === 4" :src="jmttParseText" alt="" style="width:40px;margin-top: 10px;">
      <div v-for="eachRemark in vipData['VipRemark']" :key="eachRemark" :style="hcf.getTextStyle({
        addSize:-2,color:HNewGameUIConfig.newGameUIType === 3? '#ffffff88': '#0008'
      })">{{ eachRemark }}
      </div>
    </div>
  </div>
</template>


<script setup>
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {showToast} from "vant";
  import HAvatar from "@/components/utils/HAvatar.vue";
  import {emitter, hcf} from "@/components/utils/HComFunctions.js";
  import {hr} from "@/components/utils/HRouter.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  import HCacheImage from "@/components/utils/HCacheImage.vue";
  import {Swiper, SwiperSlide} from 'swiper/vue';
  import 'swiper/css/effect-coverflow'
  import {EffectCoverflow} from 'swiper/modules';
  import 'swiper/css';
  import 'swiper/css/effect-coverflow';
  import 'swiper/css/pagination';

  import iconVipLock from "@/assets/icons/vip/card_vip_lock.png"
  import iconVipUnLock from "@/assets/icons/vip/card_vip_unlock.png"
  import iconPVipText0 from "@/assets/icons/vip/vip_privilege_text_0.png"
  import iconPVipText1 from "@/assets/icons/vip/vip_privilege_text_1.png"
  import iconPVipText2 from "@/assets/icons/vip/vip_privilege_text_2.png"
  import iconPVipText3 from "@/assets/icons/vip/vip_privilege_text_3.png"
  import iconPVipText4 from "@/assets/icons/vip/vip_privilege_text_4.png"
  import iconPVipText5 from "@/assets/icons/vip/vip_privilege_text_5.png"
  import iconPVipText6 from "@/assets/icons/vip/vip_privilege_text_6.png"
  import iconPVipText7 from "@/assets/icons/vip/vip_privilege_text_7.png"
  import iconPVipText8 from "@/assets/icons/vip/vip_privilege_text_8.png"
  import iconPVipText9 from "@/assets/icons/vip/vip_privilege_text_9.png"
  import iconPVipText10 from "@/assets/icons/vip/vip_privilege_text_10.png"
  import HParseColoredText from "@/components/utils/HParseColoredText.vue";
  import HCountdownTimer from "@/components/utils/HCountdownTimer.vue";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import VipRenderCircleWidgets from "@/components/pages/VipRenderCircleWidgets.vue";

  const props = defineProps(["hideNav", "dynamicColoCallback"]);

  const iconPVipTextArray = [iconPVipText0, iconPVipText1, iconPVipText2, iconPVipText3, iconPVipText4, iconPVipText5,
    iconPVipText6, iconPVipText7, iconPVipText8, iconPVipText9, iconPVipText10];
  const user = useUserStore();
  const http = useHHttp();
  const vipData = ref(null);
  const mySwiper = ref(null);
  const curSwiperIndex = ref(user.vipLevel);
  const scrollTagRef = ref(null);

  const dynamicBgColor = ref(getVipLevelBgColor());
  if (props.dynamicColoCallback) {
    props.dynamicColoCallback(dynamicBgColor.value);
  }
  const dynamicTextColor = ref(getVipLevelBgColor({isButtonBg: true}));
  const tempVipLevel = ref(user.vipLevel);
  const iconVipFlag = computed(() => {
    return hcf.getNewGameUIIcon(`vip_flag_icon_${user.vipLevel}.png`);
  });
  const iconVipLevel = computed(() => {
    return hcf.getNewGameUIIcon(`vip_level_${user.vipLevel}.png`);
  });
  const iconVipNextLevel = computed(() => {
    return hcf.getNewGameUIIcon(`vip_level_${user.vipLevel + 1}.png`);
  });
  const progressValue = computed(() => {
    let value = Math.floor((vipData.value['CurrentExp'] / vipData.value['NextExp'] * 100));
    return value >= 100 ? 100 : value;
  });

  const icon_top_bg = hcf.getNewGameUIIcon(`vip_tequan_top_bg.jpg`);
  const icon_vip_tequan_flag_left = hcf.getNewGameUIIcon(`vip_tequan_flag_left.png`);
  const icon_vip_tequan_flag_right = hcf.getNewGameUIIcon(`vip_tequan_flag_right.png`);

  const jmttTopBg = hcf.getNewGameUIIcon(`vip_area_bg.png`);
  const iconCardLeft = hcf.getNewGameUIIcon(`vip_card_left.png`);
  const iconCardRight = hcf.getNewGameUIIcon(`vip_card_right.png`);
  const jmttPrivilegesBg = hcf.getNewGameUIIcon(`privileges_bg.png`);
  const jmttEachPrivilegesBg = hcf.getNewGameUIIcon(`each_privileges_bg.png`);
  const jmttCardBg =hcf.getNewGameUIIcon(`card_bg.png`);
  const jmttVipDetailBtn = hcf.getNewGameUIIcon(`btn_detail.png`);
  const jmttParseText = hcf.getNewGameUIIcon(`parse_text.png`);

  const hsCardBg = hcf.getNewGameUIIcon(`vip_medium_bg.jpg`);


  const vipCircleRef = ref();

  function clickTaskBtn(eachTask) {
    http.request("/app/active/vip/award",
        (datas) => {
          if (datas["Desc"] != null) {
            emitter.emit(
                "TASK_SUCCESS_VISIBLE",
                {
                  "Visible": true,
                  "Money": datas["Money"],
                  "Title": datas["Title"],
                  "Desc": datas["Desc"],
                });
          }
          useHComApi().refreshUserBalance();
          updateDatas();
        }, {
          loadingDelayMillTime: 0,
          params: {
            "Id": eachTask["Id"],
            "Type": eachTask["Type"],
          }
        });
  }

  const getJbBtnColor = computed(() => {
    return HNewGameUIConfig.newGameUIType === 1
        ? "linear-gradient(to right, #FFE300, #FFCC00)"
        : HNewGameUIConfig.newGameUIType === 2
            ? "linear-gradient(to right, #f86974, #FE5765)"
            : HNewGameUIConfig.newGameUIType === 3
                ? "linear-gradient(to right, #FFC901, #FEB602)"
                : "linear-gradient(to right, #8DA7FF, #5079FF)";
  });

  function scrollToCenter(index, isAnimate = true) {
    if(HNewGameUIConfig.newGameUIType === 3){
      return;
    }
    let targetYValue = 65 * (index - 1);
    if (isAnimate) {
      scrollTagRef.value.scrollTo({
        left: targetYValue,
        behavior: 'smooth'
      });
    } else {
      scrollTagRef.value.scrollLeft = targetYValue;
    }
  }

  function swiperChange(swiper) {
    let isLeft = (swiper["activeIndex"] ?? 0) < curSwiperIndex.value;
    curSwiperIndex.value = swiper["activeIndex"] ?? 0;
    setCurTempLevelStyle(curSwiperIndex.value);
    scrollToCenter(curSwiperIndex.value);
    if (props.dynamicColoCallback) {
      props.dynamicColoCallback(dynamicBgColor.value);
    }
    if(HNewGameUIConfig.newGameUIType === 3){
      vipCircleRef.value.setCurLevel(curSwiperIndex.value, isLeft, vipData.value['VipInfo'].length);
    }
  }

  function setControlledSwiper(swiper) {
    mySwiper.value = swiper;
  }

  function goSwiperPageByIndex(level = -1) {

    let targetIndex = level === -1 ? user.vipLevel : level;

    if (mySwiper.value) {
      mySwiper.value.slideTo(targetIndex);
    }
    if(HNewGameUIConfig.newGameUIType === 3 && vipCircleRef.value) {
      vipCircleRef.value.setCurLevel(targetIndex, false, vipData.value['VipInfo'].length);
    }
  }

  function goVipDetail() {
    hr.go("vip-detail");
  }

  function getBackTextBtnBgColor() {
    return HNewGameUIConfig.newGameUIType === 4
        ? "#FFDAD5"
        : (HNewGameUIConfig.newGameUIType === 1 ||
            HNewGameUIConfig.newGameUIType === 2)
            ? "#6C6C6C"
            : HNewGameUIConfig.newGameUIType === 3
                ? "black"
                : getVipLevelBgColor(
                    {isButtonBg: true}
                );
  }

  function getSwiperTextColor() {
    return HNewGameUIConfig.newGameUIType === 1
        ? "#8091a9"
        : HNewGameUIConfig.newGameUIType === 2
            ? "black"
            : "white";
  }

  function setCurTempLevelStyle(level) {
    tempVipLevel.value = level;
    dynamicBgColor.value = getVipLevelBgColor({vipLevel: level});
    dynamicTextColor.value = getVipLevelBgColor({vipLevel: level, isButtonBg: true});
  }

  function getVipLevelBgColor({isButtonBg = false, vipLevel} = {}) {
    let targetBgColor = hcf.getMainColor();
    let targetLevel = vipLevel ?? user.vipLevel;
    switch (targetLevel) {
      case 0:
        targetBgColor =
            isButtonBg ? "#9EABBE" : "#EBF2F9";
        break;
      case 1:
        targetBgColor =
            isButtonBg ? "#7D98E0" : "#ECF1FF";
        break;
      case 2:
        targetBgColor =
            isButtonBg ? "#74A5E6" : "#E9F2FC";
        break;
      case 3:
        targetBgColor =
            isButtonBg ? "#9795E2" : "#F0F0FF";
        break;
      case 4:
        targetBgColor =
            isButtonBg ? "#B193EF" : "#F5F1FF";
        break;
      case 5:
        targetBgColor =
            isButtonBg ? "#CE82CD" : "#FAF2FA";
        break;
      case 6:
        targetBgColor =
            isButtonBg ? "#E570AF" : "#FFF3FA";
        break;
      case 7:
        targetBgColor =
            isButtonBg ? "#F56767" : "#FFF4F4";
        break;
      case 8:
        targetBgColor =
            isButtonBg ? "#F98558" : "#FFF6F3";
        break;
      case 9:
        targetBgColor =
            isButtonBg ? "#E89F5C" : "#FDF7F0";
        break;
      case 10:
        targetBgColor =
            isButtonBg ? "#443932" : "#F5F5F5";
        break;
    }
    return targetBgColor;
  }

  function updateDatas() {

    http.request("/app/active/vip", (data) => {
      if (data["VipLevel"] != null) {
        user.vipLevel = data["VipLevel"];
      }

      vipData.value = data;

      setCurTempLevelStyle(user.vipLevel);

      goSwiperPageByIndex(user.vipLevel);
    }, {
      errCallBack: (resp) => {
        if (resp["m"]) {
          showToast(resp["m"] ?? "");
        }
      }
    });
  }

  onMounted(() => {
    updateDatas();
  });
</script>


<style scoped>
  .scrollable-tags {
    display: flex;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* iOS 流畅滚动 */
    scrollbar-width: none; /* Firefox */
  }

  .scrollable-tags::-webkit-scrollbar {
    display: none; /* Chrome */
  }

  .eachTag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 3px 10px;
    font-weight: bold;
    font-size: 14px;
    border-radius: 6px;
    flex-shrink: 0;
  }
</style>
